import styled from "styled-components";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import MaterialInput from "components/Inputs/MaterialInput";
import { Box, Paper, TextField, Typography, Link as MuiLink } from "@mui/material";
import { nativePageScrollRegion, nativePageShell } from "styles/nativePageLayout";


export const CalendarSectionContainer = styled.div`
  margin-bottom: 1rem;
  font-size: 16px;
`

export const StyledCalendarTodayIcon = styled(CalendarTodayIcon)`
  opacity: 0.5;
`

export const CalendarContainer = styled.div`
  margin: 0.75rem 0;
`

export const HeaderContainer = styled.div`
  background: var(--common-white-main, #fff);
  border: 1px solid var(--primary-blue, #0B4598);
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  border-radius: var(--borderRadius, 8px);
  padding: 1rem 1rem 0.5rem 1rem;
  margin-bottom: 1rem;
    h2 {
    font-size: 1rem;
    }
    p {
    font-size: 0.75rem;
    font-style: normal;
    line-height: 166%;
    letter-spacing: 0.4px;
  }
`

export const FooterContainer = styled.div`
  background: var(--background-success, #F1F7FF);
  border-radius: var(--borderRadius, 8px);
  padding: 1rem 1rem 0.5rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.75rem;
  font-style: normal;
  line-height: 166%;
  letter-spacing: 0.4px;
  p {
    margin-bottom: 1rem;
  }
`

export const StyledLink = styled.a`
  color: var(--primary-blue, #0B4598);
  cursor: pointer;
  text-decoration: underline;
`

// New styled components from SecondStep.tsx

export const PageShell = styled.div`
  ${nativePageShell};
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
`

export const FormField = styled(TextField)`
  margin-bottom: 24px;
  .MuiInputBase-root {
    border-radius: 8px;
  }
  .MuiInputBase-input {
    text-align: left;
  }
  input::placeholder, textarea::placeholder {
    opacity: 0.7;
    font-style: normal;
  }
`

export const MainContainer = styled(Box)`
  ${nativePageScrollRegion};
  background-color: #fff;
  padding-bottom: 8px;
  scroll-padding-top: 16px;
  overscroll-behavior: contain;

  .MuiFormControl-root {
    scroll-margin-top: 16px;
  }
`

export const ContentContainer = styled(Box)`
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
  padding-top: 32px;
  padding-bottom: 96px;
`

export const PageTitle = styled(Typography)`
  font-weight: bold;
  color: var(--primary-blue);
  margin-bottom: 24px;
  text-align: center;
`

export const BluePaper = styled(Paper)`
  padding: 24px;
  margin-bottom: 32px;
  border-radius: 8px;
  background-color: #e6f0ff;
  border: 1px solid #ccdcff;
`

export const InfoPaper = styled(Paper)`
  padding: 24px;
  margin-bottom: 32px;
  border-radius: 8px;
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
`

export const SectionTitle = styled(Typography)`
  font-weight: bold;
  color: var(--primary-blue);
  font-size: 1rem;
`

export const GuideLink = styled(MuiLink)`
  color: var(--primary-blue);
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  padding: 4px 0;
  
  /* Improve touch target size for mobile */
  @media (max-width: 768px) {
    padding: 8px 0;
    margin: 4px 0;
  }
`

export const InfoTitle = styled(Typography)`
  font-weight: bold;
`

export const InfoText = styled(Typography)`
  line-height: 1.6;
  text-align: left;
  margin-bottom: 16px;
`

export const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 15px 0;
  margin-left: auto;
  margin-right: auto;
  max-width: 800px;
`

export const DescriptionField = styled(FormField)`
  .MuiOutlinedInput-root {
    height: auto;
    min-height: 180px;
  }
  .MuiInputBase-input {
    align-items: flex-start;
    line-height: 1.5;
  }
  textarea::placeholder {
    opacity: 0.7;
    position: relative;
    line-height: 1.5;
    transition: opacity 0.2s ease;
  }
  textarea:focus::placeholder {
    opacity: 0.4;
  }
`
